import React, { useEffect, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { Typography } from "@material-ui/core";
import { PrimaryColor } from "../../shared/styles/colors";
import { useSearchParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import Permission from "../../model/permission";
import useStyles from "./styles";
import PermissionModal from "./PermissionModal";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35rem",
  bgcolor: "background.paper",
  order: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "80%",
  },
};

interface Props {
  permission: Permission;
  resetList: () => void;
  onOpen?: (id?: string) => void;
  onClose?: () => void;
}

const PermissionDetailModal = ({
  permission,
  resetList,
  onOpen,
  onClose,
}: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleOpen = () => {
    setOpen(true);
    if (onOpen) {
      onOpen(permission.id?.toString());
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    const permissionId = searchParams.get("permissionId");
    if (!open && permissionId && permissionId === permission.id?.toString()) {
      handleOpen();
    }
  }, [searchParams]);

  return (
    <div>
      <Button onClick={handleOpen}>
        <MoreVertIcon sx={{ color: PrimaryColor }} />
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "auto" }}
      >
        <Box sx={style}>
          <div className={classes.headerDiv}>
            <Typography className={classes.title}>Permission info</Typography>
            <div className={classes.headerSubDiv}>
              <PermissionModal permission={permission} resetList={resetList} />
              <Button onClick={handleClose} sx={{ color: "black" }}>
                <CloseIcon />
              </Button>
            </div>
          </div>
          <hr />
          <div className={classes.form}>
            <Typography>Name</Typography>
            <Typography className={classes.inputDetail}>
              {permission.name}
            </Typography>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default PermissionDetailModal;
